import type { Product } from '@velasca/types'

/**
 * It should apply some transformation to product data received from product.xxx.liquid.
 *
 */
export const transformProductPageData = (product: Product): Product => {
  const { relatedSoles } = product

  let transfromedProduct = product

  if (!relatedSoles) {
    return transfromedProduct
  }

  relatedSoles.sort((soleA, soleB) => {
    const titleA = soleA.title.toLowerCase()
    const titleB = soleB.title.toLowerCase()

    if (titleA < titleB) {
      return -1
    }
    if (titleA > titleB) {
      return 1
    }

    return 0
  })

  transfromedProduct = {
    relatedSoles,
    ...product,
  }

  return transfromedProduct
}
